import { blogsArray } from "app/data/blogData"

export const getBlogArticleByID = (articleID) => {
  return blogsArray.find(blog => blog.id === +articleID)
}